module.exports = "../../../../platform/assets/pageMainIcon/youth_jichudanganlei6.svg";